// extracted by mini-css-extract-plugin
export default {"JHeroSection":"JHero_JHeroSection__gfhCK"};